import React, { Component } from "react";
import { Row } from "antd";
import { LinkForModal } from "./styles";
import SharedAccessModal from './AccessModal';

export default class KnowAccessLevel extends Component {
  state = {
    modalVisible: false
  };

  setModalVisible(modalVisible) {
    this.setState({ modalVisible });
  }

  render() {
    return (
      <div className={`${this.props.styling}`}>
        <LinkForModal id="anrKnowAccessLevel" data-test="anrKnowAccessLevel" onClick={() => this.setModalVisible(true)}>
          Learn more about access levels
        </LinkForModal>
        <Row>
          { this.state.modalVisible ?
            <SharedAccessModal
              data-test="sharedAccessModal"
              setModalVisible={(value) => this.setModalVisible(value)}
              modalVisible = {this.state.modalVisible}
            />: null
          }
        </Row>
      </div>
    );
  }
}
